import React from 'react';
import {
  Card, CardHeader, CardText, Checkbox, RaisedButton, LinearProgress,
} from 'material-ui';
import PropTypes from 'prop-types';
import { commitMutation, graphql } from 'react-relay';

import environment from '../../relay/environment';

const AmenityPrograms = ({ programs }) => {
  let programEls = [<li key='0'>(none listed)</li>];
  if (programs.length > 0) {
    programEls = programs.map(
      (program, index) => <li key={index}>{program}</li>);
  }

  return <ul>{programEls}</ul>;
};

AmenityPrograms.propTypes = {
  programs: PropTypes.arrayOf(PropTypes.string),
};

AmenityPrograms.defaultProps = {
  programs: [],
};

const Contact = ({ contact }) => {
  const { email, name = '', position = '' } = contact;

  let displayString = email;
  let nameString = name;
  if (position !== '') {
    nameString = `${name} (${position})`;
  }
  if (nameString !== '') {
    displayString = `${nameString} <${email}>`;
  }

  return <span>{displayString}</span>;
};

Contact.propTypes = {
  contact: PropTypes.shape().isRequired,
};

const Contacts = ({ contacts }) => {
  let contactEls = [<li key='0'>(none listed)</li>];
  if (contacts.length > 0) {
    contactEls = contacts.map(
      (contact, index) => <li key={index}><Contact contact={contact} /></li>);
  }

  return <ul>{contactEls}</ul>;
};

Contacts.propTypes = {
  contacts: PropTypes.arrayOf(PropTypes.string),
};

Contacts.defaultProps = {
  contacts: [],
};

export default class MergeVendors extends React.Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  static propTypes = {
    toKeep: PropTypes.shape().isRequired,
    toMerge: PropTypes.shape().isRequired,
    goBack: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    const { toKeep, toMerge } = this.props;
    const left = { ...toKeep };
    const right = { ...toMerge };

    if (typeof left.contacts === 'string') {
      left.contacts = JSON.parse(left.contacts);
    } else {
      left.contacts = [];
    }

    if (typeof right.contacts === 'string') {
      right.contacts = JSON.parse(right.contacts);
    } else {
      right.contacts = [];
    }

    const mergedData = { ...left };
    const selectionData = {
      name: 'left',
      sabreCode: 'left',
      contacts: 'left',
      amenityPrograms: 'left',
    };

    if (!left.sabreCode && right.sabreCode) {
      mergedData.sabreCode = right.sabreCode;
      selectionData.sabreCode = 'right';
    } else if (!left.sabreCode && !right.sabreCode) {
      selectionData.sabreCode = 'none';
    }

    if (left.contacts.length === 0 && right.contacts.length > 0) {
      mergedData.contacts = right.contacts;
      selectionData.contacts = 'right';
    } else if (left.contacts.length === 0 && right.contacts.length === 0) {
      selectionData.contacts = 'none';
    }

    if (left.amenityPrograms.length === 0 && right.amenityPrograms.length > 0) {
      mergedData.amenityPrograms = right.amenityPrograms;
      selectionData.amenityPrograms = 'right';
    } else if (left.amenityPrograms.length === 0 && right.amenityPrograms.length === 0) {
      selectionData.amenityPrograms = 'none';
    }

    this.state = {
      left,
      right,
      mergedData,
      selectionData,
      working: false,
    };
  }

  selectSimple = (field, option) => (e, checked) => {
    const { mergedData, selectionData } = this.state;
    const selectedVendor = this.state[option];

    if (checked === true) {
      mergedData[field] = selectedVendor[field];
      selectionData[field] = option;
    } else {
      mergedData[field] = '';
      selectionData[field] = 'none';
    }

    this.setState({ mergedData, selectionData });
  }

  selectList = (field, option) => (e, checked) => {
    const { mergedData, selectionData } = this.state;
    const selectedVendor = this.state[option];

    if (checked === true) {
      mergedData[field] = selectedVendor[field];
      selectionData[field] = option;
    } else {
      mergedData[field] = [];
      selectionData[field] = 'none';
    }

    this.setState({ mergedData, selectionData });
  }

  cancel = () => {
    this.props.goBack();
  }

  merge = () => {
    const { toKeep: { id: toKeep }, toMerge: { id: toMerge } } = this.props;
    const {
      mergedData: { name, sabreCode, contacts, amenityPrograms },
    } = this.state;

    this.setState({ working: true });

    const input = { toKeep, toMerge, name, sabreCode, contacts, amenityPrograms };

    commitMutation(
      environment,
      {
        mutation: graphql`
          mutation MergeVendors_Merge_Mutation (
            $input: MergeVendorsInput!
          ) {
            mergeVendors(input: $input) {
              vendor {
                name,
                sabreCode,
                contacts,
                amenityPrograms
              }
            }
          }
        `,
        variables: { input },
        onCompleted: () => { window.location = `/edit/${toKeep}/`; },
        onError: err => alert(err),
      }
    );
  }


  render() {
    const {
      left, right, mergedData: { name, sabreCode, contacts, amenityPrograms },
      selectionData, working,
    } = this.state;

    const disabled = {
      left: {
        name: working || left.name === right.name,
        sabreCode: working || !left.sabreCode || left.sabreCode === right.sabreCode,
        contacts: working || (
          left.contacts.length === 0 || left.contacts === right.contacts
        ),
        amenityPrograms: working || (
          left.amenityPrograms.length === 0 ||
          left.amenityPrograms === right.amenityPrograms
        ),
      },
      right: {
        name: working || left.name === right.name,
        sabreCode: working || !right.sabreCode || left.sabreCode === right.sabreCode,
        contacts: working || (
          right.contacts.length === 0 || left.contacts === right.contacts
        ),
        amenityPrograms: working || (
          right.amenityPrograms.length === 0 ||
          left.amenityPrograms === right.amenityPrograms
        ),
      },
    };

    return (<div>
      <CardHeader title='Merged Vendor Data' />
      <CardText>
        <div style={styles.vendorData}>
          <div>
            <span style={styles.fieldName}>Name:</span>
            <span style={styles.fieldContent}>{name}</span>
          </div>
          <div>
            <span style={styles.fieldName}>Sabre Code:</span>
            <span style={styles.fieldContent}>
              {sabreCode || '(unknown)'}
            </span>
          </div>
          <h4>Contacts</h4>
          <Contacts contacts={contacts} />
          <h4>Amenity Programs</h4>
          <AmenityPrograms programs={amenityPrograms} />
        </div>
        <div style={styles.sideBySideContainer}>
          <Card style={styles.sideBySideData}>
            <CardText>
              <div style={styles.vendorData}>
                <Checkbox
                  value={left.name}
                  label={left.name}
                  disabled={disabled.left.name}
                  checked={selectionData.name === 'left'}
                  onCheck={this.selectSimple('name', 'left')}
                />
                <Checkbox
                  value={left.sabreCode}
                  label={left.sabreCode ? left.sabreCode : '(unknown)'}
                  disabled={disabled.left.sabreCode}
                  checked={selectionData.sabreCode === 'left'}
                  onCheck={this.selectSimple('sabreCode', 'left')}
                />
                <Checkbox
                  value={left.contacts}
                  label='Contacts'
                  disabled={disabled.left.contacts}
                  checked={selectionData.contacts === 'left'}
                  onCheck={this.selectList('contacts', 'left')}
                />
                <Contacts contacts={left.contacts} />
                <Checkbox
                  value={left.amenityPrograms}
                  label='Amenity Programs'
                  disabled={disabled.left.amenityPrograms}
                  checked={selectionData.amenityPrograms === 'left'}
                  onCheck={this.selectList('amenityPrograms', 'left')}
                />
                <AmenityPrograms programs={left.amenityPrograms} />
              </div>
            </CardText>
          </Card>
          <Card style={styles.sideBySideData}>
            <CardText>
              <div style={styles.vendorData}>
                <Checkbox
                  value={right.name}
                  label={right.name}
                  disabled={disabled.right.name}
                  checked={selectionData.name === 'right'}
                  onCheck={this.selectSimple('name', 'right')}
                />
                <Checkbox
                  value={right.sabreCode}
                  label={right.sabreCode ? right.sabreCode : '(unknown)'}
                  disabled={disabled.right.sabreCode}
                  checked={selectionData.sabreCode === 'right'}
                  onCheck={this.selectSimple('sabreCode', 'right')}
                />
                <Checkbox
                  value={right.contacts}
                  label='Contacts'
                  disabled={disabled.right.contacts}
                  checked={selectionData.contacts === 'right'}
                  onCheck={this.selectList('contacts', 'right')}
                />
                <Contacts contacts={right.contacts} />
                <Checkbox
                  value={right.amenityPrograms}
                  label='Amenity Programs'
                  disabled={disabled.right.amenityPrograms}
                  checked={selectionData.amenityPrograms === 'right'}
                  onCheck={this.selectList('amenityPrograms', 'right')}
                />
                <AmenityPrograms programs={right.amenityPrograms} />
              </div>
            </CardText>
          </Card>
        </div>
        <div style={styles.buttons}>
          { working ? <LinearProgress mode='indeterminate' /> : <div>
            <RaisedButton
              style={styles.button}
              secondary
              label='Cancel'
              onTouchTap={this.cancel}
              disabled={working}
            />
            <RaisedButton
              style={styles.button}
              primary
              label='Confirm Merge'
              onTouchTap={this.merge}
              disabled={working}
            /></div>}
        </div>
      </CardText>
    </div>);
  }
}

const styles = {
  vendorData: {
    display: 'flex',
    flexDirection: 'column',
  },
  fieldName: {
    fontWeight: 'bold',
    marginRight: 5,
  },
  sideBySideContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: '2 0 auto',
    justifyContent: 'space-between',
  },
  sideBySideData: {
    width: '49%',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: 5,
    width: '100%',
  },
  button: {
    marginLeft: 5,
  },
};



// WEBPACK FOOTER //
// /src/components/Vendors/MergeVendors.js